<template>
  <div class="grant">
    <section class="intro">
      <img
        src="@/assets/images/banner-ksg@1x.jpg"
        srcset="
          @/assets/images/banner-ksg@1x.jpg 1x,
          @/assets/images/banner-ksg@1x.jpg 2x,
          @/assets/images/banner-ksg@1x.jpg 3x
        "
        alt="Photo of Kathy Stanford Grant"
        class="banner"
      />
      <div class="intro-content">
        <h1 class="h1 narrow">Kathy Stanford Grant</h1>
        <h1 class="h2 wide">Kathy Stanford Grant</h1>
        <h3 class="h3">Pioneer. Visionary. Teacher.</h3>
        <hr>
      </div>
    </section>

    <div class="arrow">
      <a href="#primary">
        <img src="@/assets/images/icon-arrow-circle-down.svg" alt="Scroll down illustration" />
      </a>
      <div class="h5">Kathy's Story</div>
    </div>

    <section class="primary" id="primary">
      <div class="primary-inner">
        <div class="flex">
          <p class="p3">Kathleen Stanford Grant (1921-2010), was a first-generation Pilates teacher who studied directly under Joseph Pilates and taught the Pilates method for more than 50 years. Kathy was also an acclaimed dancer, choreographer and arts administrator.  In her many roles and throughout her life, Kathy brought her hallmark energy, experience, enthusiasm and fire, to everything she did and all of the students, clients and audiences, she touched.</p>

          <div class="embed-container">
            <iframe title="Video with Kathy Stanford Grant" width="560" height="315" src="https://www.youtube.com/embed/bXfcUodpwa4" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <p class="p3" style="margin-top: 20px; font-style:italic;">
            Video courtesy of <a href="https://carareeserpilates.com/" style="color:white;" target="_blank">carareeserpilates.com</a></p>
        </div>

      </div>
      <span class="triangle" />
    </section>

    <section class="content">
      <div class="content-inner">
        <p class="p1">Kathleen Standford Grant was born August 21, 1921 in Boston, Massachusetts. At age 9, Kathy began taking ballet classes at the Boston Conservatory of Music. During her high school years, Kathy spent her summers studying ballet at Carnegie Hall in New York. Her love of movement became her lifelong passion.</p>
        <p class="p1">In the 1940s, Kathy moved to New York and became a popular chorus girl and dance captain for the Zanzibar Club in Harlem. She was featured in a Life magazine photo spread and danced in the hit Broadway productions of "Harlem Cavalcade" and "Finian's Rainbow." She performed with legendary dancers Bill 'Bojangles' Robinson, Cab Calloway, Pearl Bailey, Carmen De Lavallade and Geoffrey Holder. The Claude Marchant Dance Company took her to dance in Spain and Italy, and she performed with companies from South America to the Middle East.</p>
        <p class="p1">In 1953, Kathy returned to New York where she danced with Arthur Mitchell and Donald McKayle.  In 1954, after knee surgery, Kathy was referred to Joseph Pilates for rehab. It was just a few years later that Kathy began teaching Pilates at Carola Trier’s studio and studying directly under Joe. Kathy received her certification in Contrology (Pilates) from the New York State Vocational Rehabilitation Program in a program based on completing 2,200 hours of work with Joseph Pilates in 1964-65.</p>
        <p class="p1">In early 1970s, Kathy became the Executive Director at the Dance Theatre of Harlem. She subsequently ran the popular Pilates program at Henri Bendel. She was the first African-American Panelist for the National Endowment for the Arts, and was a distinguished member of the New York Council of the Arts.</p>
        <p class="p1">In 1988, she began teaching Pilates at the Tisch School of the Arts at New York University.  Kathy created her program, Before the Hundred, to prepare the body for the Pilates exercises. She taught by cueing through “song” that consisted of strong images to help students understand. For example, “zip tight jeans” meant connecting to your abdominals. Over time she cued in short-hand “zipper”. She was known for knowing bodies better than anyone.</p>
        <p class="p1">Kathy Grant died on May 27, 2010 at the age of 88. She was a pioneer and great innovator in the Pilates community. She lived a full life as a professional dancer, choreographer, arts administrator and Master Pilates Teacher. Her work lives on through those she taught and mentored, and the many lives and programs she touched.</p>
      </div>
      <span class="triangle" />
    </section>

    <section class="bio">
      <div class="bio-inner">
        <img
          src="@/assets/images/img-sarita-allen@1x.png"
          srcset="
            @/assets/images/img-sarita-allen@1x.png 1x,
            @/assets/images/img-sarita-allen@2x.png 2x,
            @/assets/images/img-sarita-allen@3x.png 3x
          "
          alt="Photo of Sarita Allen"
        />
        <div class="bio-content">
          <h5 class="h5">Remembrances</h5>
          <h2 class="h2">Sarita Allen</h2>
          <p class="p3">Dancer, Educator, 2nd Generation Pilates Master</p>
          <hr>
          <p class="p1">Dance has taken me all over the world, performing at some of the most mystical and prestigious venues like the Pyramids of Giza, the legendary Bolshoi, the divine La Scala and the majestic Paris Opera. I even danced at the White House of the United States, twice. The alignment of my connection with Kathy Grant was quite fateful. When I first arrived at the Dance Theater of Harlem, Kathy was the director of the school and taught Pilates in a curriculum she called Special Exercise. As a dancer, I was greatly influenced by the work of Kathy, one of only two people Mr. Pilates certified himself. I became her protégée. She took me under her wing and taught me firsthand her unique way of interpreting the work. I believe Kathy was one of the reasons I had such an illustrious career in dance; she kept me from getting injured, she said to me “I’m going to make you strong enough to withstand any tour!” and she did. Kathy was a very accomplished and talented dancer herself, she understood what was necessary for my body’s optimal expression as a dancer and an artist, that intuition was why she was such an excellent teacher. While still dancing, Kathy incurred a pretty severe knee injury during a performance when she initially came to Joseph Pilates for sessions at Pearl Bailey’s suggestion. We’re talking about a determined little girl who at the age of 8 years old received a full scholarship to the Boston Conservatory, where she studied classical ballet for nine years and then at the International School of Dance at Carnegie Hall. She worked her way up to dance captain at the famous Club Zanzibar in Harlem, setting high standards as a performer and also breaking barriers in one of the first interracial Broadway shows. Even with her expert level of talent and training there were very few opportunities for women of color to dance in America. She did, however, have a successful career dancing in Europe and was still able to achieve impressive levels of success in the arts considering the challenges of discrimination in her time. Kathleen Stanford Grant was truly a trailblazer that will continue to inspire generations of practitioners in the years to come. Reminding us to know our history, to critically look with the same discernment that we use to assess the body and our alignment with it.</p>
        </div>
      </div>
    </section>

    <section class="quote">
      <div class="quote-inner">
        <img src="@/assets/images/quotes.svg" alt="Quotation marks" />
        <div class="flex">
          <p class="callout">No matter where you go, you have to remember your center. You don't do it physically, you do it mentally—do it inside. Let your mind direct your body. It's really, really quiet. You got to know where your strong point is and as you get better, try and go to the weak point.</p>
          <hr>
          <h5 class="h5">Kathy Stanford Grant</h5>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
  export default {
    name: "Grant",

    metaInfo: {
      title: "Kathy Stanford Grant",
      titleTemplate: "%s | Diversity in Pilates",
      meta: [
        {
          name: "description",
          content: "Kathleen Stanford Grant (1921-2010), was a first-generation Pilates teacher who studied directly under Joseph Pilates and taught the Pilates method for more than 50 years. Kathy was also an acclaimed dancer, choreographer and arts administrator."
        }
      ]
    },
  }
</script>

<style scoped>
.narrow {
  display: block;
}

.wide {
  display: none;
}

.banner {
  width: 100%;
  height: 400px;
  object-fit: cover;
  object-position: 36% center;
}

.arrow {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding-bottom: 26px;
  padding-top: 50px;
}

.arrow .h5 {
  color: #81746C;
  margin-top: 10px;
}

.intro-content {
  padding: 35px 34px 10px 32px;
}

hr {
  border: none;
  border-top: 4px dotted #9EB675;
  margin: 40px 0 0;
  width: 158px;
}

.primary {
  padding: 65px 32px;
  position: relative;
  background-color: var(--warm3);
}

.intro .h3 {
  color: var(--gold1);
  margin-top: 10px;
}

.primary .p3 {
  color: var(--white);
  margin: 0;
}

.primary-inner {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
}

.video-thumb {
  width: 100%;
  max-width: 587px;
  margin-top: 40px;
}

.triangle {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: max(268px, 35vw) 0 0 max(324px, 45vw);
  border-color: transparent transparent transparent var(--warm4);
  position: absolute;
  bottom: 0;
  left: 0;
}

.content {
  background-color: var(--warm1);
  overflow: hidden;
  position: relative;
}

.content-inner {
  padding: 64px 32px 36px;
  max-width: 764px;
  margin: 0 auto;
  position: relative;
  z-index: 10;
}

.content-inner .p1 {
  margin-bottom: 28px;
}

.content .triangle {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: max(268px, 100vw) 0 0 max(324px, 110vw);
  border-color: transparent transparent transparent var(--warm2);
}

.bio {
  padding: 65px 0;
}

.bio img {
  width: 100%;
  max-width: 400px;
  display: block;
  margin: 0 auto;
  position: relative;
  left: -32px;
}

.bio-inner {
  margin: 0 auto;
  max-width: 765px;
}

.bio-content {
  padding: 45px 32px 0;
}

.bio-content .h5 {
  margin-bottom: 5px;;
  color: var(--warm3);
}

.bio-content hr {
  border: none;
  border-top: 4px dotted var(--green5);
  margin: 20px 0 40px;
  width: 158px;
}

.quote {
  background-color: var(--green3);
  padding: 65px 32px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.quote-inner {
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.quote .flex {
  max-width: 700px;
}

.quote img {
  margin: 6px 10px 0 0;
}

.quote hr {
  border: none;
  border-top: 4px dotted var(--green5);
  margin: 35px 0 16px;
  width: 70px;
}

.quote .h5 {
  color: #919191;
}

.embed-container { 
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
  margin-top: 25px;
}

.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media only screen and (min-width: 768px) {
  .narrow {
    display: none;
  }

  .wide {
    display: block;
  }

  .intro {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1052px;
    margin: 0 auto;
    padding: 0 min(calc(1084px - 100vw), 32px);
  }

  hr {
    margin: 30px 0;
  }

  .intro-content {
    order: 1;
    width: 41%;
    padding: 0;
  }

  .arrow {
    padding-top: 0;
  }

  .banner {
    order: 2;
    width: 57%;
    max-width: 607px;
    height: 440px;
  }

  .primary {
    overflow: hidden;
    padding: 96px min(calc(1084px - 100vw), 32px);
  }

  .primary .p3 {
    margin-bottom: 0;
  }

  .video-thumb {
    margin-top: 60px;
  }

  .content-inner {
    padding: 90px 32px 62px;
  }

  .bio img {
    float: left;
    margin-right: 30px;
    margin-left: -15px;
    max-width: 306px;
    position: relative;
    left: 0;
  }

  .bio-content hr {
    margin: 30px 0 16px 292px;
  }

  .bio-content {
    padding: 0 32px;
  }
}
</style>
